export var contentViewTypes;

(function (contentViewTypes) {
  contentViewTypes["POST"] = "post";
  contentViewTypes["SESSION"] = "session";
  contentViewTypes["PROFILE"] = "profile";
  contentViewTypes["VIDEO"] = "video";
})(contentViewTypes || (contentViewTypes = {}));